import Spinner from '../indicators/Spinner';

export const FileLoadingSpinner = () => {
  return <Spinner className="text-border-base-back-3 p-2" />;
};

